/** Hook for consuming the GoBarContext. */
import { useContext } from 'react';
import { GoBarContext } from '@/features/search/GoBarContext.def';

export const useGoBar = () => {
  const context = useContext(GoBarContext);
  if (context === undefined || context === null) {
    throw new Error('useGoBar must be used within a GoBarProvider');
  }
  return context;
};
